'use client';

import {usePathname} from 'next/navigation';
import Script from 'next/script';
import {useEffect, useRef} from 'react';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export function MetaPixel({pixelId}: {pixelId: string}) {
  const pathname = usePathname();
  // The init snippet already tracks the first PageView; only client-side
  // navigations need to re-fire it, so the initial pathname is skipped.
  const initialPathname = useRef<string | null>(pathname);

  useEffect(() => {
    if (pathname === initialPathname.current) {
      return;
    }
    initialPathname.current = null;
    window.fbq?.('track', 'PageView');
  }, [pathname]);

  // The fbq stub queues calls from the first render on; fbevents.js replays that
  // queue, so the SDK itself can wait until the page has loaded.
  return (
    <>
      <Script id="meta-pixel" strategy="afterInteractive">
        {`!function(f){if(f.fbq)return;var n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[]}(window);
fbq('init', '${pixelId}');
fbq('track', 'PageView');`}
      </Script>
      <Script id="meta-pixel-sdk" src="https://connect.facebook.net/en_US/fbevents.js" strategy="lazyOnload" />
      <noscript>
        <img
          height="1"
          width="1"
          style={{display: 'none'}}
          alt=""
          src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
        />
      </noscript>
    </>
  );
}

MetaPixel.displayName = 'MetaPixel';
